var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "illust",
    clipPath: "url(#clip0_450_18290)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.6485 86.6479L5 97.874V31.2241L39.6485 20V86.6479Z",
    fill: "#E4E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M108.943 86.6479L74.2969 97.874V31.2241L108.943 20V86.6479Z",
    fill: "#E4E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.6484 86.6479L74.2969 97.874V31.2241L39.6484 20V86.6479Z",
    fill: "#F2F3F4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M114.395 95.9734L111.206 99.1767C110.4 99.9868 109.092 99.9868 108.286 99.1767L93.748 84.5702C96.1409 82.919 98.2136 80.8371 99.8533 78.4336L114.395 93.0401C115.202 93.8502 115.202 95.1633 114.395 95.9734Z",
    fill: "#A5AAAB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.4723 41.4961C67.5148 41.4961 56.9727 52.0851 56.9727 65.1003C56.9727 78.1155 67.5148 88.7045 80.4723 88.7045C85.3955 88.7045 89.9678 87.175 93.7479 84.5675C96.1408 82.9163 98.2135 80.8344 99.8532 78.4309C102.453 74.636 103.972 70.0434 103.972 65.1003C103.972 52.0851 93.4319 41.4961 80.4723 41.4961ZM94.1604 72.7128C92.7362 75.2853 90.6163 77.4188 88.0551 78.8493C85.808 80.1026 83.2243 80.8179 80.4744 80.8179C71.8469 80.8179 64.8264 73.7682 64.8264 65.1003C64.8264 56.4324 71.849 49.3827 80.4744 49.3827C89.0997 49.3827 96.1223 56.4324 96.1223 65.1003C96.1223 67.8604 95.4102 70.4556 94.1625 72.7128H94.1604Z",
    fill: "#C4C8C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.12 65.1024C96.12 67.8625 95.4079 70.4577 94.1602 72.7148C92.736 75.2874 90.6161 77.4208 88.0549 78.8514C85.8078 80.1047 83.2241 80.82 80.4741 80.82C71.8467 80.82 64.8262 73.7702 64.8262 65.1024C64.8262 56.4345 71.8488 49.3848 80.4741 49.3848C89.0995 49.3848 96.1221 56.4345 96.1221 65.1024H96.12Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M94.1602 72.7148C92.736 75.2874 90.6161 77.4208 88.0549 78.8514C85.8078 80.1047 83.2241 80.82 80.4741 80.82C71.8467 80.82 64.8262 73.7702 64.8262 65.1024C64.8262 56.4345 71.8488 49.3848 80.4741 49.3848C89.0995 49.3848 96.1221 56.4345 96.1221 65.1024C96.1221 67.8625 95.41 70.4577 94.1623 72.7148H94.1602Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_18290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.5ecc9c3184d52b5bc10e88ee27258bd0.svg";
export { ForwardRef as ReactComponent };